package com.partejar.app.core.network

import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.auth.Auth
import io.ktor.client.plugins.auth.clearAuthTokens
import io.ktor.client.plugins.auth.providers.BearerTokens
import io.ktor.client.plugins.auth.providers.bearer
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.http.encodedPath
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

import com.partejar.app.core.session.SessionTokenStore

fun createHttpClient(
    tokenStore: SessionTokenStore,
    refreshCoordinator: SessionRefreshCoordinator
): HttpClient {
    return HttpClient {
        configurePartejarHttpClient(tokenStore, refreshCoordinator)
    }
}

internal fun HttpClientConfig<*>.configurePartejarHttpClient(
    tokenStore: SessionTokenStore,
    refreshCoordinator: SessionRefreshCoordinator
) {
    install(ContentNegotiation) {
        json(Json {
            ignoreUnknownKeys = true
            isLenient = true
        })
    }
    install(HttpTimeout) {
        requestTimeoutMillis = 15000
        connectTimeoutMillis = 10000
        socketTimeoutMillis = 15000
    }
    install(Auth) {
        bearer {
            loadTokens {
                tokenStore.current()?.let { tokens -> BearerTokens(tokens.accessToken, tokens.refreshToken) }
            }
            refreshTokens {
                refreshCoordinator.refresh(client, oldTokens) {
                    markAsRefreshTokenRequest()
                }
            }
            sendWithoutRequest { request ->
                !request.url.encodedPath.isPublicUnauthenticatedPath()
            }
        }
    }
}

fun HttpClient.invalidateSessionTokenCache() {
    clearAuthTokens()
}

private val PUBLIC_AUTH_PATHS = setOf(
    "/auth/login",
    "/auth/register",
    "/auth/refresh",
    "/actuator/health",
    "/convites/aceite/validate"
)

private fun String.isPublicUnauthenticatedPath(): Boolean =
    this in PUBLIC_AUTH_PATHS || startsWith("/assinaturas/contratos/") || startsWith("/convites/aceite/")
